module.exports = __webpack_public_path__ + "static/media/Onboarding_Four.67d7a341.png";